import { render, staticRenderFns } from "./RevisionMutationV2.vue?vue&type=template&id=49a6e589&"
import script from "./RevisionMutationV2.vue?vue&type=script&lang=js&"
export * from "./RevisionMutationV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports